import Placeholder from "components/Placeholder";
import StarringYouCards from "components/StarringYouCards";

const LoadingPlaceholder = () => {
  return (
    <>
      <Placeholder data-testid="placeholder" variant="rect" style={{ paddingTop: "22.5%", margin: [0, "auto", 40] }} />
      <StarringYouCards loading />
    </>
  );
};

export default LoadingPlaceholder;
